import { createSelector } from 'reselect';
import { experienceSelector } from 'selectors/testTarget/offers/stickyNavBarPdp/experience/experienceSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { STICKY_NAV_BAR_PDP } from 'constants/TestTarget';

const showStickyNavBarPdpSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: testReady && experience === STICKY_NAV_BAR_PDP.CHALLENGER_ONE,
    challengerTwo: testReady && experience === STICKY_NAV_BAR_PDP.CHALLENGER_TWO
}));

export { showStickyNavBarPdpSelector };
